export const BACKEND_TIME_FORMAT = 'HH:mm'

export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD'

export const TRANSACTION_DATE_TIME_FORMAT = 'MM/DD/YYYY [at] hh:mm a'

export const LONG_DATE_TIME_FORMAT = "LLLL d, yyyy 'at' t"

export const SHORT_DATE_TIME_FORMAT = 'MMMM DD YYYY hh:mma'
